import { render, staticRenderFns } from "./InspectionHomeworkPersonal.vue?vue&type=template&id=4dfb93c6&scoped=true"
import script from "./InspectionHomeworkPersonal.vue?vue&type=script&lang=js"
export * from "./InspectionHomeworkPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb93c6",
  null
  
)

export default component.exports